import { useStoreState } from '@store/hooks'

export function useSellerId(): string | undefined {
  return useStoreState((state) => state.seller.currentId)
}
